import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API_BASE = "https://eluvent.com/api";

// ============================
// PROGRAMS (no demo, no price clutter)
// ============================
const programs = [
  {
    id: 1,
    subject: "Chemistry",
    topic: "Excel in Chemistry for Board Exams",
    program: "7‑month program | 3 classes per week | 90 minutes each",
    board: "CBSE / ICSE",
    price: "₹1,500/month",
    description:
      "Master mole concept, stoichiometry, organic chemistry, and more. Full syllabus coverage with regular tests. Small batch of 5‑7 students.",
  },
  {
    id: 2,
    subject: "Physics",
    topic: "Excel in Physics for Board Exams",
    program: "7‑month program | 3 classes per week | 90 minutes each",
    board: "CBSE / ICSE",
    price: "₹1,500/month",
    description:
      "Conquer electricity, magnetism, optics, and modern physics. Step‑by‑step concept building with numerical solving. Small batch of 5‑7 students.",
  },
  {
    id: 3,
    subject: "Mathematics",
    topic: "Excel in Mathematics for Board Exams",
    program: "7‑month program | 3 classes per week | 90 minutes each",
    board: "CBSE / ICSE",
    price: "₹1,500/month",
    description:
      "From polynomials to probability – strengthen fundamentals and problem‑solving speed with expert guidance. Small batch of 5‑7 students.",
  },
  {
    id: 4,
    subject: "Biology",
    topic: "Excel in Biology for Board Exams",
    program: "7‑month program | 3 classes per week | 90 minutes each",
    board: "CBSE / ICSE",
    price: "₹1,500/month",
    description:
      "Detailed explanation of life processes, genetics, evolution, and environmental science. Small batch of 5‑7 students.",
  },
  {
    id: 5,
    subject: "English",
    topic: "Excel in English for Board Exams",
    program: "7‑month program | 3 classes per week | 90 minutes each",
    board: "CBSE / ICSE",
    price: "₹1,500/month",
    description:
      "Improve reading comprehension, writing skills, grammar, and literature analysis. Small batch of 5‑7 students.",
  },
];

// ============================
// LEAD CAPTURE FORM (same logic as main chat)
// ============================
const LeadFormModal = ({ onClose }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const submitLead = async () => {
    if (!form.name.trim()) return setError("Name is required.");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return setError("Valid email is required.");
    if (!/^\d{8,15}$/.test(form.phone)) return setError("Phone number must contain 8‑15 digits.");
    try {
      await axios.post(`${API_BASE}/capture-lead`, {
        name: form.name,
        email: form.email,
        phone: form.phone,
        session_id: "classroom_lead",
      });
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Please try again.");
    }
  };

  if (submitted) {
    return (
      <div style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.6)", display: "flex",
        justifyContent: "center", alignItems: "center", zIndex: 1000,
      }}>
        <div style={{ background: "white", borderRadius: 20, padding: 24, maxWidth: 400, width: "90%", textAlign: "center" }}>
          <h2>✅ Thank You!</h2>
          <p>We will get in touch with you shortly to discuss the program and class timings.</p>
          <button onClick={onClose} style={{
            padding: "10px 24px", background: "#10b981", color: "white",
            border: "none", borderRadius: 12, fontSize: 14, fontWeight: 700, cursor: "pointer"
          }}>
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: "rgba(0,0,0,0.6)", display: "flex",
      justifyContent: "center", alignItems: "center", zIndex: 1000,
    }}>
      <div style={{ background: "white", borderRadius: 20, padding: 24, maxWidth: 400, width: "90%" }}>
        <h2>Contact Us</h2>
        <p style={{ color: "#475569", fontSize: 14 }}>Fill your details and we will reach out to you with program details and demo class link.</p>
        <input placeholder="Full Name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={{ width: "100%", padding: 10, marginBottom: 12, borderRadius: 10, border: "2px solid #e2e8f0", fontSize: 14, boxSizing: "border-box" }} />
        <input placeholder="Email Address" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} style={{ width: "100%", padding: 10, marginBottom: 12, borderRadius: 10, border: "2px solid #e2e8f0", fontSize: 14, boxSizing: "border-box" }} />
        <input placeholder="Phone Number" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} style={{ width: "100%", padding: 10, marginBottom: 16, borderRadius: 10, border: "2px solid #e2e8f0", fontSize: 14, boxSizing: "border-box" }} />
        {error && <p style={{ color: "#ef4444", fontSize: 13, marginBottom: 10 }}>{error}</p>}
        <button onClick={submitLead} style={{ width: "100%", padding: 12, background: "linear-gradient(135deg, #fca311, #ff8c42)", color: "white", border: "none", borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: "pointer" }}>Submit & We'll Contact You</button>
        <button onClick={onClose} style={{ width: "100%", padding: 10, marginTop: 8, background: "transparent", color: "#64748b", border: "none", fontSize: 13, cursor: "pointer" }}>Close</button>
      </div>
    </div>
  );
};

// ============================
// MAIN CLASSROOM PAGE
// ============================
const Classroom = () => {
  const [showLeadForm, setShowLeadForm] = useState(false);

  return (
    <div style={{
      fontFamily: "'Nunito', sans-serif",
      background: "#f8fafc",
      minHeight: "100vh",
      overflowY: "auto",
      padding: 0,
    }}>
      {/* Hero */}
      <div style={{
        background: "linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)",
        color: "white",
        padding: "40px 20px",
        textAlign: "center",
      }}>
        <h1 style={{ fontSize: "36px", margin: 0 }}>🎓 Eluvent Live Classes</h1>
        <p style={{ fontSize: "18px", marginTop: 8, opacity: 0.9 }}>
          Comprehensive 7‑month coaching programs for CBSE & ICSE board exams. Small batches of 5‑7 students.
        </p>
        <Link
          to="/"
          style={{
            display: "inline-block",
            marginTop: 20,
            padding: "12px 28px",
            background: "white",
            color: "#1e3a5f",
            borderRadius: 30,
            fontWeight: "bold",
            textDecoration: "none",
          }}
        >
          Try the AI Tutor first →
        </Link>
      </div>

      {/* About Eluvent */}
      <div style={{ maxWidth: 1100, margin: "40px auto", padding: "0 20px" }}>
        <h2 style={{ textAlign: "center", color: "#1e293b", marginBottom: 24 }}>
          Why Eluvent is Your Best Partner for Board Exams
        </h2>

        <div style={{
          background: "white",
          borderRadius: 20,
          padding: 30,
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
          lineHeight: 1.8,
          fontSize: 16,
          color: "#334155",
        }}>
          <p>
            <strong>Board exams are the most important exams of a student’s life.</strong>{" "}
            Unlike entrance exams, you can appear for them <strong>only once</strong> – there is no second
            chance. A high score in your board exam is the <strong>foundation of a good future</strong>,
            opening doors to top colleges and career paths.
          </p>

          <p style={{ marginTop: 20 }}>
            <strong>Eluvent is built from the ground up to help you excel in these critical exams.</strong>{" "}
            Our AI Tutor doesn’t answer generic questions – it follows the <strong>strict CBSE & ICSE
            Class X syllabus</strong>. Every doubt you ask, every test you take, and every diagram you snap
            is answered with your board curriculum in mind.
          </p>

          <p style={{ marginTop: 20 }}>
            <strong>What makes us different?</strong>
          </p>

          <ul style={{ paddingLeft: 20 }}>
            <li>
              <strong>🤖 AI Tutor with Syllabus Guard:</strong> Our AI never goes off‑syllabus. It knows
              exactly what chapters are in your board and gives answers that help you write perfect exam
              answers.
            </li>
            <li>
              <strong>🔮 Exam Predictor:</strong> Take 5 topic tests (20 questions each) and our weighted
              prediction engine tells you your estimated board exam score. It even breaks down your
              performance by difficulty (easy/medium/hard) so you know where to improve.
            </li>
            <li>
              <strong>👨‍🏫 Seasoned Teachers:</strong> When you need human help, our certified CBSE & ICSE
              teachers step in – either for a quick doubt or a full live class.
            </li>
            <li>
              <strong>📚 Structured Long‑Term Programs:</strong> Our 7‑month classroom programs (below)
              cover every chapter, with three 90‑minute live classes per week, regular tests, and
              personalised feedback. Small batch size of 5‑7 students.
            </li>
          </ul>

          <p style={{ marginTop: 20 }}>
            <strong>We don’t just teach – we prepare you to score your best in the one exam that matters
            most.</strong> That’s the Eluvent promise.
          </p>
        </div>
      </div>

      {/* Programs List */}
      <div style={{ maxWidth: 1100, margin: "40px auto", padding: "0 20px" }}>
        <h2 style={{ textAlign: "center", color: "#1e293b", marginBottom: 24 }}>
          🗓️ Long‑Term Coaching Programs
        </h2>
        <div style={{ display: "grid", gap: 24 }}>
          {programs.map((p) => (
            <div
              key={p.id}
              style={{
                background: "white",
                borderRadius: 16,
                padding: 20,
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                borderLeft: "4px solid #10b981",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1 1 300px" }}>
                <h3 style={{ margin: 0, color: "#1e293b" }}>
                  {p.subject} – {p.topic}
                </h3>
                <p style={{ margin: "6px 0", color: "#475569", fontSize: 14 }}>
                  📅 {p.program} &nbsp;|&nbsp; 🏫 {p.board}
                </p>
                <p style={{ fontSize: 13, color: "#64748b", margin: "8px 0" }}>
                  {p.description}
                </p>
                <div style={{ marginTop: 10, fontSize: 14, color: "#475569" }}>
                  <span>💰 <strong>{p.price}</strong></span>
                </div>
              </div>
              <div style={{ marginTop: 12 }}>
                <button
                  onClick={() => setShowLeadForm(true)}
                  style={{
                    padding: "12px 24px",
                    background: "#fca311",
                    color: "white",
                    border: "none",
                    borderRadius: 30,
                    fontWeight: 800,
                    fontSize: 15,
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(252,163,17,0.3)",
                  }}
                >
                  ✋ Contact Us
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Us banner */}
        <div style={{
          textAlign: "center",
          marginTop: 30,
          padding: 20,
          background: "white",
          borderRadius: 16,
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}>
          <h3 style={{ color: "#1e293b" }}>📞 Interested in a batch?</h3>
          <p style={{ color: "#475569", fontSize: 14, margin: "8px 0 16px" }}>
            Contact us and we will get in touch with you to discuss the program, demo class, and schedule.
          </p>
          <button
            onClick={() => setShowLeadForm(true)}
            style={{
              padding: "12px 28px",
              background: "linear-gradient(135deg, #fca311, #ff8c42)",
              color: "white",
              border: "none",
              borderRadius: 30,
              fontWeight: 800,
              fontSize: 16,
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(252,163,17,0.3)",
            }}
          >
            ✋ Contact Us
          </button>
        </div>
      </div>

      {/* Lead Form Modal */}
      {showLeadForm && <LeadFormModal onClose={() => setShowLeadForm(false)} />}

      {/* Footer */}
      <div style={{ textAlign: "center", padding: 20, color: "#64748b", fontSize: 13 }}>
        <Link to="/" style={{ color: "#2c5282", textDecoration: "none" }}>
          ← Back to AI Tutor
        </Link>
        <p style={{ marginTop: 8 }}>© 2026 Eluvent. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Classroom;